import React, { Component } from 'react';
import FJVerticalScroller from '../FJScroller/FJVerticalScroller';
import styles from './FJVirtualizedMixView.module.less';

class FJVirtualizedMixView extends Component {
    _viewHeight = 0;
    _offsetHeight = 0;
    constructor(props) {
        super(props);
        this.state = {
            viewWidth: props.viewWidth, // 视图的宽度
            pageRect: [],
        };
        this._scrollerRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.list && this.props.list.length > 0) {
            this.init();
        }

        if (!this.state.viewWidth) this._updateViewWidth();
        else this._view.style.height = this._viewHeight + 'px';
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            prevProps.list.length !== this.props.list.length ||
            JSON.stringify(prevProps.list) !== JSON.stringify(this.props.list) ||
            JSON.stringify(prevProps.childrenSizeList) !== JSON.stringify(this.props.childrenSizeList) ||
            this.props.updateVirtualizedMixView
        ) {
            this.init();
            if (!this.state.viewWidth) this._updateViewWidth();
            else {
                if (this.props.list && this.props.list.length > 0) {
                    this._view.style.height = this._viewHeight + 'px';
                } else {
                    this._view.style.height = 0 + 'px';
                }
            }
        } else {
            if (!this.state.viewWidth) this._updateViewWidth();
            else {
                if (this.props.list && this.props.list.length > 0) {
                    this._view.style.height = this._viewHeight + 'px';
                } else {
                    this._view.style.height = 0 + 'px';
                }
            }

            // 该组件使用的时候可能会用 display: none 来隐藏 _scroller，这样会导致在数据更新后 _onScroll 方法里
            // 获取到的 offsetHeight 为 0，接着导致计算 pageRect 出问题，所以需要记录一个 offsetHeight，更新后再刷新 pageRect
            // 同时需要在 pageRect 有值的时候才做这件事情，防止 _init 之后调用，此时 pageRect 还不对
            const offsetHeight = this._scrollerRef.current.getScroller().offsetHeight;
            if (this._offsetHeight !== offsetHeight && this.state.pageRect.length > 0) {
                this._offsetHeight = offsetHeight;
                this._onScroll();
            }
        }
    }

    /**
     * @description 滚动到指定位置
     * @param top
     */
    scrollTop = top => {
        this._scrollerRef.current.scrollTop(top);
    };

    /**
     * @description 初始化
     * @private
     */
    init = () => {
        if (!this.props.list || this.props.list.length === 0) {
            return;
        }
        let x = 0,
            y = 0;
        let bottoms = []; // 一行中的元素的底部的位置
        let { row, rowSpace, verticalSpace, childrenSizeList } = this.props;
        if (typeof rowSpace === 'undefined') rowSpace = 0;
        if (typeof verticalSpace === 'undefined') verticalSpace = 0;

        let pageRect = [];
        for (let i = 0; i < childrenSizeList.length; i++) {
            let childrenSize = childrenSizeList[i];
            if (i < row) {
                bottoms.push(childrenSize.height);
                x = i * (childrenSize.width + rowSpace);
            } else {
                let minHeight = Math.min(...bottoms);
                let index = bottoms.indexOf(minHeight);
                x = index * (childrenSize.width + rowSpace);
                y = minHeight + verticalSpace;
                bottoms[index] = y + childrenSize.height;
            }

            pageRect.push({
                left: x,
                top: y,
                width: childrenSize.width,
                height: childrenSize.height,
                active: true,
            });
        }

        let viewHeight = Math.max(...bottoms);
        this._viewHeight = viewHeight + verticalSpace;
        this._onScroll(pageRect);
    };

    _onScroll = pageRect => {
        const scroller = this._scrollerRef.current.getScroller();
        // 显示区域最大height
        let offsetHeight = scroller.offsetHeight;
        // 滚动条距离上边的距离
        let scrollTop = scroller.scrollTop;

        let list = typeof pageRect === 'undefined' ? JSON.parse(JSON.stringify(this.state.pageRect)) : pageRect;
        let newList = list.map(item => {
            let bottom = item.top + item.height;
            if (bottom < scrollTop - 50 || item.top > scrollTop + offsetHeight + 50) {
                // 隐藏
                item.active = false;
            } else {
                item.active = true;
            }
            return item;
        });

        this.setState({
            pageRect: newList,
        });
    };

    /**
     * @desc 保存视图的width并刷新组件
     * @private
     */
    _updateViewWidth = () => {
        let rect = this._view.getBoundingClientRect();
        if (rect && rect.width !== 0) {
            this.setState({ viewWidth: rect.width });
        }
    };

    /**
     * @desc 返回混排的items
     * @param {Array <Component>} childrens - 被包含的组件队列
     * @return {null|*[]}
     * @private
     */
    _getList = () => {
        if (!this.props.list || this.props.list.length === 0) {
            return null;
        }

        if (this.state.pageRect.length === 0) {
            return null;
        }

        let list = [];
        for (let i = 0; i < this.state.pageRect.length; i++) {
            const itemRect = this.state.pageRect[i];
            if (itemRect.active) {
                list.push(this.props.renderItem(itemRect, this.props.list[i], i));
            }
        }
        return list;
    };

    render() {
        const { className, innerClassName, childrenSizeList, getData, onScrollStart, totalScrollThreshold } =
            this.props;

        return (
            <FJVerticalScroller
                ref={this._scrollerRef}
                className={className}
                onScroll={this._onScroll}
                onScrollStart={onScrollStart}
                onTotalScroll={getData}
                totalScrollThreshold={totalScrollThreshold}
            >
                <div className={innerClassName}>
                    <div ref={ele => (this._view = ele)} className={styles.view_box} style={this.props.viewStyle}>
                        {this.state.viewWidth && childrenSizeList && childrenSizeList.length !== 0
                            ? this._getList()
                            : null}
                    </div>
                    {this.props.children}
                </div>
            </FJVerticalScroller>
        );
    }
}

export default FJVirtualizedMixView;
